import React, { useState, useEffect } from 'react';

import './styles.scss';

import Text from '../Text';
import { Column, Row } from 'components/Layout/Grid';

import ProtocolPainelSevice from 'services/protocolPainel.service';

export default function ProtocolPainel() {
  interface Y {
    queued: string;
    in_attendance: string;
    done: string;
    self_attendance: string;
  }

  const _protocolPanelService = new ProtocolPainelSevice();

  const [protocolPanel, setprotocolPanel] = useState<Y>();

  useEffect(() => {
    _protocolPanelService
      .GetProtocols()
      .then((response) => setprotocolPanel(response));
  }, []);

  return (
    <Column
      className="bg-background w-60 w-md-100 order-md-1 pl-3 pt-3 pl-md-0"
      style={{ borderRadius: '10px' }}
    >
      <Row className="d-flex align-center pl-md-3">
        <Text size={24} className="color-primary font-bold">
          Painel de protocolos
        </Text>
      </Row>
      <Row className="mt-4 protocol-info-box justify-between px-4 flex-wrap">
        <Column className="protocol-info-item justify-center pl-2 flex-1 ml-1 w-sm-50 maxw-md-40 ml-md-0">
          <Text size={13} className="color-blue-gray font-bold text-wrap">
            EM FILA
          </Text>
          <Text size={48} className="color-secondary font-bold">
            {protocolPanel?.queued}
          </Text>
        </Column>
        <Column className="protocol-info-item justify-center pl-2 flex-1 ml-1 w-sm-50 maxw-md-40 ml-md-0">
          <Text size={13} className="color-blue-gray font-bold text-wrap">
            EM ATENDIMENTO
          </Text>
          <Text size={48} className="color-secondary font-bold">
            {protocolPanel?.in_attendance}
          </Text>
        </Column>
        <Column className="protocol-info-item justify-center pl-2 flex-1 ml-1 w-sm-50 maxw-md-40 ml-md-0">
          <Text size={13} className="color-blue-gray font-bold text-wrap">
            FINALIZADOS
          </Text>
          <Text size={48} className="color-secondary font-bold">
            {protocolPanel?.done}
          </Text>
        </Column>
        <Column className="protocol-info-item justify-center pl-2 flex-1 ml-1 w-sm-50 maxw-md-40 ml-md-0">
          <Text size={13} className="color-blue-gray font-bold text-wrap">
            AUTO ATENDIMENTO
          </Text>
          <Text size={48} className="color-secondary font-bold">
            {protocolPanel?.self_attendance}
          </Text>
        </Column>
      </Row>
    </Column>
  );
}
